<ul #elmAvatar class="nav-actions">
  <li *ngFor="let item of routes; index as indice" class="action-item text-center">
    <a (href)="'/' + item.path"
    appDebounceClick id="Menu Lateral_PTEC-Menu Izquierda {{item.name}}" title="{{item.description}}"
    class="color-blue-dark d-block link" [routerLink]="'/' + item.path" [queryParams]="{id: item.param}"
      *ngIf="!item.childrens">
      <span class="u-round d-block bg-gray-light">
        <em aria-hidden="true" class="material-icons">{{item.icon}}</em>
      </span> {{item.name}}
    </a>
    <a href="javascript:" (click)="clickPaga()" #menuAside  aria-expanded="false" appDebounceClick id="Menu Lateral_PTEC-Menu Izquierda {{item.name}}"
    title="{{item.description}}" class="color-blue-dark d-block" *ngIf="item.childrens" style="cursor: pointer;">
      <span class="u-round d-block bg-gray-light link">
        <em aria-hidden="true" class="material-icons">{{item.icon}}</em>
      </span> {{item.name}}
    </a>
    <div #dropAvatar *ngIf="item.childrens">
      <ul class="actions-submenu bg-gray-light pdd-btm-30" [ngClass]="{'is-active' : dropActive , 'is-inactive' : !dropActive }"
        data-menu="paga">
        <div class="bg-blue-dark color-white text-center menu-header download p-relative">
          Descarga
          <em aria-hidden="true" class="material-icons download-close link" (click)="clickPaga()">
            close
          </em>
        </div>

        <li class="actions-submenu_item pb-24 link" *ngFor="let children of item.childrens; let indexMenu = last">

          <a (click)="clickPaga()" (blur)="hiddeToggle($event)" (focus)="onfocusLastItem(indexMenu)"
            appDebounceClick id="Menu Lateral_PTEC-Descarga {{children.name}}" title="{{children.name}}"
            class="color-blue-dark font-14 list " [routerLink]="'/' + children.path"
            [queryParams]="{id: children.param}">
            <em aria-hidden="true" class="material-icons">{{children.icon}}</em>
            {{children.name}}
          </a>
        </li>
      </ul>
    </div>
  </li>
</ul>
